import { api } from "../../lib";

export interface Procedure {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreateProcedureInput {
  name: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateProcedureInput extends Partial<CreateProcedureInput> {
  id: string;
}

export const proceduresService = {
  getAll: async () => {
    return api.get<Procedure[]>("/admin/procedures");
  },

  getById: async (id: string) => {
    return api.get<Procedure>(`/admin/procedures/${id}`);
  },

  create: async (input: CreateProcedureInput) => {
    return api.post<Procedure>("/admin/procedures", {
      name: input.name,
      description: input.description,
      isActive: input.isActive ?? true,
    });
  },

  update: async (input: UpdateProcedureInput) => {
    const { id, ...updates } = input;
    return api.put<Procedure>(`/admin/procedures/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/procedures/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<Procedure>(`/admin/procedures/${id}`, {
      isActive,
    });
  },
};
